var _defs, _ellipse, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolPack390({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 8,
    cy: 8,
    rx: 7,
    ry: 7.02
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.76,10.73V5H5.38a3,3,0,0,1,.91.11,1.45,1.45,0,0,1,.71.5,2.52,2.52,0,0,1,.47.91,4.63,4.63,0,0,1,.17,1.31,4.25,4.25,0,0,1-.28,1.65,1.93,1.93,0,0,1-.74,1,2.13,2.13,0,0,1-1.17.29Zm.62-.68h1a1.68,1.68,0,0,0,.92-.2,1.27,1.27,0,0,0,.48-.63A3.86,3.86,0,0,0,7,7.83a3.18,3.18,0,0,0-.24-1.37,1.25,1.25,0,0,0-.6-.67,2,2,0,0,0-.8-.11h-1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.84,8.72l.62.19a2.65,2.65,0,0,1-.72,1.44,1.77,1.77,0,0,1-1.26.48,1.91,1.91,0,0,1-1.11-.32,2.26,2.26,0,0,1-.76-1,4.17,4.17,0,0,1-.3-1.66,3.84,3.84,0,0,1,.3-1.6,2.27,2.27,0,0,1,.8-1,2,2,0,0,1,1.12-.33,1.71,1.71,0,0,1,1.17.42,2.28,2.28,0,0,1,.69,1.24l-.61.18c-.21-.79-.63-1.19-1.26-1.19a1.38,1.38,0,0,0-.81.24,1.57,1.57,0,0,0-.55.75A3.36,3.36,0,0,0,9,7.82a3,3,0,0,0,.42,1.77,1.28,1.28,0,0,0,1.1.59,1.22,1.22,0,0,0,.88-.36A2,2,0,0,0,11.84,8.72Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPack390);
export default __webpack_public_path__ + "static/media/Symbol_pack_390.aca73847a9311d0cacbc78fa7a8c62d9.svg";
export { ForwardRef as ReactComponent };